import React from "react";
import {Link} from "react-router-dom";


export default function Footer(props) {
  function handleTechBulletin(e) {
    e.preventDefault()
    alert('The Tech Bulletin is arriving soon!')
  }

  return (
    <section className="footer">
      <div className="container">
        <div className="content">

          <div className="row align-items-center p-4 ps-0 pe-0">
            <div className="col-12 col-sm-8">

              <ul className="list-group list-group-horizontal mb-3">
                <li className="list-inline-item"><Link to="/privacy">Privacy Policy</Link></li>
                <li className="list-inline-item"><Link to="/contact">Contact</Link></li>
              </ul>

            </div>

            <div className="col-12 col-sm-4">

              <form className="form-inline" action="">

                <div className="input-group">
                  <input type="email" className="form-control" id="email" placeholder="Enter Email for Tech Bulletin"
                         name="email" />
                  <button type="button" onClick={handleTechBulletin} className="btn btn-primary">Join</button>
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
